const defaultSvgIcon = 'ic-plugins-24';

const svgIconsMap: Common.IMap<string> = {
	'fa-tasks': 'ic-progress-24',
	'fa-tag': 'ic-price-24',
	'fa-cube': 'ic-box-24',
	'fa-th-large': 'ic-grid-24',
	'fa-check': 'ic-check-24',
	'fa-cog': 'ic-settings-24',
	'fa-cubes': 'ic-boxes-24',
	'fa-home': 'ic-dashboard-alt-24',
	'fa-list-alt': 'ic-list-alt-24',
	'fa-arrow-right': 'ic-arrow-right-24',
	'fa-plug': 'ic-integrations-24',
	'fa-globe': 'ic-domain-24',
	'fa-list-ul': 'ic-file-text-24',
	'fa-address-card-o': 'ic-customers-24',
	'fa-pie-chart': 'ic-chart-24',
	'fa-dollar': 'ic-usd-24',
	'fa-shopping-cart': 'ic-shopping-cart-24',
	'fa-sitemap': 'ic-sales-channel-24',
	'fa-bullhorn': 'ic-horn-24',
	'fa-pencil-square-o': 'ic-pencil-square-24',
	'cf-users': 'ic-users-24',
	'fa-suitcase': 'ic-business-24',
	'fa-file-text-o': 'ic-list-24',
	'fa-cogs': 'ic-cogs-24',
	'fa-credit-card': 'ic-credit-card-24',
	'fa-briefcase': 'ic-finance-24',
	'fa-binoculars': 'ic-console-24',
	'fa-archive': 'ic-product-24',
	'fa-certificate': 'ic-loyalty-24',
	'fa-star': 'ic-loyalty-24',
	'fa-life-ring': 'ic-support-alt-24',
	'fa-external-link-square': 'ic-external-24',
	'fa-shield': 'ic-security-24',
	'fa-book': 'ic-book-24',
	'fa-search': 'ic-lightbulb-24',
	'fa-exchange': 'ic-migration-24',
	'fa-money': 'ic-erp-24',
	'fa-graduation-cap': 'ic-education-24',
	'fa-cloud-download': 'ic-storage-24',
	'fa-handshake-o': 'ic-partnership-24'
};

export default svgIconsMap;

export { defaultSvgIcon };
